// extracted by mini-css-extract-plugin
export var sbShowMain = "itemsList-module--sb-show-main--34PVz";
export var wrapper = "itemsList-module--wrapper--2Y9b-";